import { Header } from 'components/molecules';
import EditAMTemplate from 'components/templates/AMTemplate/EditAMTemplate';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Automation Manager' }];

const EditAMPage = () => {
  return (
    <>
      <Header
        title="Automation Manager"
        subtitle="Edita un Automation Manager"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <EditAMTemplate />
    </>
  );
};

export default withAuth(EditAMPage, undefined, 'mayasoft');
